import moment, { type Moment } from 'moment-timezone';
import { TIME_ZONE_CONSTANTS } from '@/utils/timeZoneConstants';

/**
 * moment `format('z')` often returns numeric offsets ("-03", "+05:30", "+430", "+0530")
 * instead of a real abbreviation. Only trust `z` when it looks like a named abbr (has letters).
 */
function looksLikeNamedTimezoneAbbreviation(
  s: string | null | undefined
): boolean {
  if (s === null || s === undefined || s === '') return false;
  return /[A-Za-z]/.test(String(s).trim());
}

/**
 * Short timezone label for display (e.g. IST, PST, GMT+05:30).
 * Uses moment's zone abbr when it is a real name; otherwise TIME_ZONE_CONSTANTS, then GMT±offset.
 */
export function formatTimezoneAbbreviationForDisplay(
  m: Moment,
  ianaKey: string | null | undefined
): string {
  const trimmedKey =
    typeof ianaKey === 'string' && ianaKey.trim() !== ''
      ? ianaKey.trim()
      : null;

  if (trimmedKey && moment.tz.zone(trimmedKey)) {
    const fromMoment = (m.format('z') || '').trim();
    const fromConstants =
      TIME_ZONE_CONSTANTS[trimmedKey as keyof typeof TIME_ZONE_CONSTANTS]
        ?.abbreviation;
    if (fromMoment && looksLikeNamedTimezoneAbbreviation(fromMoment)) {
      return fromMoment;
    }
    if (fromConstants) return fromConstants;
  }

  return `GMT${m.format('Z')}`;
}
